
import './App.css';
import { data } from './Data'
import { BrowserRouter as Router, Switch, Route, useLocation, useHistory, Link, Redirect } from 'react-router-dom';
import Home from './Components/Home'
import Catalog from './Components/Catalog'
import Billing from './Components/Billing'
import Faq from './Components/Faq'
import Contact from './Components/Contact'
import 'bootstrap/dist/css/bootstrap.min.css';
import ProgramsByCategory from './Components/ProgramsByCategory';
import ProgramsByGrade from './Components/ProgramsByGrade';
import Navbar from './Components/Navbar';
import Footer from './Components/Footer';
import ScrollToTop from './Components/ScrollToTop';
import {Fragment} from 'react'
function App() {



return <>      



<Router>
<Navbar  />
        <Switch>
          <ScrollToTop>
          <Route exact path='/'>
            <Home />
          </Route>
     
          <Route path='/faq'>
            <Faq />
          </Route>
          <Route path='/catalog'>
            <Catalog />
          </Route>
          <Route path='/contact'>
            <Contact/>
          </Route>
       
          </ScrollToTop>
        </Switch>
 
      </Router>

      <Footer/>
      </>


}

export default App;
